<template>
	<div class='other-data'>

		<div class='grid'>
			<div :class='{ "not-match": !isMatch(values["decline_year_from"]) }'>
				<span class='select-title'>Время ослабления, повреждения насаждения</span>

				<custom-p-select
					v-model='values["decline_year_from"].value'
					:options="info_years"
					:disabled='!actLpoIsDraft'
				/>
			</div>
			<template v-if="false">
			<div :class='{ "not-match": !isMatch(values["deadwood_year"]) }'>
				<span class='select-title'>Год образования старого сухостоя</span>

				<custom-p-select
					v-model='values["deadwood_year"].value'
					:options="info_years"
					:disabled='!actLpoIsDraft'
				/>

			</div>

			<div :class='{ "not-match": notMatchingMainDamageList }'>
				<span class='select-title'>Основная причина повреждения древесины</span>
				<custom-p-select
					v-model="mainDamageReasons"
					:options="info_nonliquid_reasons"
					multiple
					:disabled='!actLpoIsDraft'
				/>
			</div>
			</template>
		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length || notMatchingMainDamageList'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	const info_years = [];
	for (let i = new Date().getFullYear(); i >= 1700; --i) {
		const temp = {
			id: i,
			name: String(i)
		};
		info_years.push(temp);
	}
	info_years.unshift({ id: 0, name: 'нет' });

	export default {
		name: 'OtherData',
		data() {
			return {
				test: [],

				info_years,

				mainDamageReasons: [],

				values: {
					decline_year_from: {
						field: 'decline_year_from',
						inputType: 'select',
						catalog: 'info_years',
						value: null,
					},

					deadwood_year: {
						field: 'deadwood_year',
						inputType: 'select',
						catalog: 'info_years',
						value: null
					},

				}
			};
		},
		computed: {

			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			notMatchingMainDamageList() {
				if (this.mainDamageList.length !== this.mainDamageReasons.length) {
					return true;
				}

				for (const damage of this.mainDamageList) {
					if (!this.mainDamageReasons.find(d => d.id === damage.reason_id)) {
						return true;
					}
				}

				return false;
			},

			...mapState({
				lpo: state => state.selectedLpo.lpo,
				mainDamageList: state => state.selectedLpo['mainDamageList'],
				info_nonliquid_reasons: state => state.catalogs['info_nonliquid_reasons'],
			})
		},

		watch: {
			mainDamageList(val) {
				this.resetMainDamageList();
			},

		},

		methods: {
			save() {

				/* MAIN DAMAGE REASONS */

				this.saveMainDamageList(this.mainDamageReasons).then(res => {
					this.updateMainDamageList();
				});

				/* OTHER */
				if (!this.notMatchingValues.length) {
					return;
				}

				const valueList = [];


				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect ? this.values[value_name].value.id : this.values[value_name].value
					};

					valueList.push(temp);
				}


				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},
			cancel() {
				this.resetValues();
			},

			resetValues(...valueList) {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return String(item.id) === this.lpo[value.field];

						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}

				this.resetMainDamageList();
			},
			resetMainDamageList() {
				this.mainDamageReasons = [];
				for (const damage of this.mainDamageList) {
					const temp = {
						id: damage.reason_id,
						name: damage.name
					};

					this.mainDamageReasons.push(temp);
				}
			},

			isMatch(value) {
				if (value.inputType === 'input') {
					return String(value.value) === String(this.lpo[value.field]);
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return String(value.value.id) === String(this.lpo[value.field]);
					}
				}

				return false;
			},


			...mapActions('selectedLpo', [
				'saveMainDamageList',
				'updateMainDamageList',
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			const catalogs = [ 'info_nonliquid_reasons' ];

			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.resetValues();
			});

		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	
	.not-match {
		background-color: orange;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

	.p-multiselect {
		width: 100%;
	}

	.p-multiselect >>> .p-multiselect-label {
		overflow: visible;
		white-space: normal;
	}

	.p-multiselect >>> .p-multiselect-panel {
		width: 100%;
	}

	.p-multiselect >>> .p-multiselect-items-wrapper {
		width: 100%;
	}

	.p-multiselect >>> .p-multiselect-item {
		white-space: normal;
	}

</style>